import http from './api'

const route = 'app/comercial/analisefaturamento/'

export default {
  showDadosAnaliseFaturamentoVolume: (dataInicial, dataFinal, empresa, cidades, areas, supervisores, vendedores, redes, tokencontrato) => {
    return http.post(route + 'showDadosAnaliseFaturamentoVolume', {
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      empresa: empresa,
      cidades: cidades,
      areas: areas,
      supervisores: supervisores,
      vendedores: vendedores,
      redes: redes,
      tokencontrato: tokencontrato,
    })
  },

  showDadosAnaliseVariacaoVolumePrecoMedio: (dataInicial, dataFinal, empresa, cidades, areas, supervisores, vendedores, redes, tokencontrato) => {
    return http.post(route + 'showDadosAnaliseVariacaoVolumePrecoMedio', {
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      empresa: empresa,
      cidades: cidades,
      areas: areas,
      supervisores: supervisores,
      vendedores: vendedores,
      redes: redes,
      tokencontrato: tokencontrato,
    })
  },
}
